export async function loadEppoSdk() {
    const { init, offlineInit } = await import('@eppo/js-client-sdk');
    if (!init || !offlineInit) {
        throw new Error('Eppo SDK initialization exports are missing.');
    }
    return { init, offlineInit };
}
//# sourceMappingURL=loadEppoSdk.js.map